// extracted by mini-css-extract-plugin
module.exports = {"form":"CustomerAddressModal_form__3PX-J","sections":"CustomerAddressModal_sections__1a-yd","localizeBtn":"CustomerAddressModal_localizeBtn__3Mb7u"};